"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _slicedToArray = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;

var clsx_1 = __importDefault(require("clsx"));

var preact_1 = require("preact");

var hooks_1 = require("preact/hooks");

var Snackbar_css_1 = __importDefault(require("./Snackbar-css"));

var Snackbar =
/*#__PURE__*/
function () {
  function Snackbar(options) {
    _classCallCheck(this, Snackbar);

    this.items = new Map();
    this.nextItemKey = 0;
    this.root = null;
    this.darkMode = options.darkMode;
  }

  _createClass(Snackbar, [{
    key: "attach",
    value: function attach(el) {
      this.root = document.createElement("div");
      this.root.className = "-walletlink-snackbar-root";
      el.appendChild(this.root);
      this.render();
    }
  }, {
    key: "presentItem",
    value: function presentItem(itemProps) {
      var _this = this;

      var key = this.nextItemKey++;
      this.items.set(key, itemProps);
      this.render();
      return function () {
        _this.items.delete(key);

        _this.render();
      };
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items.clear();
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.root) {
        return;
      }

      preact_1.render(preact_1.h(SnackbarContainer, {
        darkMode: this.darkMode
      }, Array.from(this.items.entries()).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            itemProps = _ref2[1];

        return preact_1.h(SnackbarItem, Object.assign({}, itemProps, {
          key: key
        }));
      })), this.root);
    }
  }]);

  return Snackbar;
}();

exports.Snackbar = Snackbar;

var SnackbarContainer = function SnackbarContainer(props) {
  return preact_1.h("div", {
    class: clsx_1.default("-walletlink-snackbar-container", props.darkMode && "-walletlink-snackbar-container-dark")
  }, preact_1.h("style", null, Snackbar_css_1.default), preact_1.h("div", {
    class: "-walletlink-snackbar"
  }, props.children));
};

var SnackbarItem = function SnackbarItem(_ref3) {
  var message = _ref3.message,
      showProgressBar = _ref3.showProgressBar,
      actions = _ref3.actions;

  var _hooks_1$useState = hooks_1.useState(true),
      _hooks_1$useState2 = _slicedToArray(_hooks_1$useState, 2),
      hidden = _hooks_1$useState2[0],
      setHidden = _hooks_1$useState2[1];

  var _hooks_1$useState3 = hooks_1.useState(false),
      _hooks_1$useState4 = _slicedToArray(_hooks_1$useState3, 2),
      expanded = _hooks_1$useState4[0],
      setExpanded = _hooks_1$useState4[1];

  hooks_1.useEffect(function () {
    var timers = [window.setTimeout(function () {
      setHidden(false);
    }, 1), window.setTimeout(function () {
      setExpanded(true);
    }, 10000)];
    return function () {
      timers.forEach(window.clearTimeout);
    };
  });

  var toggleExpanded = function toggleExpanded() {
    setExpanded(!expanded);
  };

  return preact_1.h("div", {
    class: clsx_1.default("-walletlink-snackbar-item", hidden && "-walletlink-snackbar-item-hidden", expanded && "-walletlink-snackbar-item-expanded")
  }, preact_1.h("div", {
    class: "-walletlink-snackbar-item-content",
    onClick: toggleExpanded
  }, preact_1.h("div", {
    class: "-walletlink-snackbar-item-content-message"
  }, message), preact_1.h("div", {
    class: "-walletlink-snackbar-item-content-chevron",
    title: "Expand"
  })), showProgressBar && preact_1.h("div", {
    class: "-walletlink-snackbar-item-progress-bar"
  }), actions && actions.length > 0 && preact_1.h("div", {
    class: "-walletlink-snackbar-item-actions"
  }, actions.map(function (action, i) {
    return preact_1.h("div", {
      class: "-walletlink-snackbar-item-actions-item",
      key: i
    }, preact_1.h("span", {
      class: "-walletlink-snackbar-item-actions-item-info"
    }, action.info), preact_1.h("button", {
      class: "-walletlink-snackbar-item-actions-item-button",
      onClick: action.onClick
    }, action.buttonLabel));
  })));
};